export default __webpack_public_path__ + "static/media/phone.ae4d5ad9.svg";